import type { TrigKey } from './keys';

export const pl: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Matematyka · Trygonometria',
  'panel.experiment': 'Eksperyment',
  'panel.params': 'Parametry',
  'panel.scene': 'Wybierz eksperyment',
  'experiment.right-triangle.label': 'Trójkąt prostokątny',
  'experiment.unit-circle.label': 'Okrąg jednostkowy',
  'experiment.wave-studio.label': 'Studio fal',
  'experiment.identity-playground.label': 'Tożsamości',
  'experiment.triangle-solver.label': 'Solver trójkąta',
  'experiment.circular-polar.label': 'Okręg i biegunowe',
  'hint.line1': 'Przeciągaj punkty, suwaki.',
  'hint.line2': 'Treść edukacyjna żyje w geometrii, nie w tekście.',
  'rt.angle.a': 'Kąt A',
  'rt.angle.b': 'Kąt B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radiany',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tg',
  'rt.snap': 'Przyciągaj do 30°/45°/60°',
  'uc.units': 'Jednostki',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tg',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'ctg',
  'uc.show.astc': 'Pokaż ASTC',
  'uc.snap.common': 'Przyciągaj do typowych kątów',
  'uc.angle.value': '∠',
  'uc.units.deg': 'stopnie',
  'uc.units.rad': 'rad',
  'uc.units.both': 'stopnie+rad',
  'ws.fn': 'Funkcja',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tg',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'ctg',
  'ws.amplitude': 'A — Amplituda',
  'ws.frequency': 'B — Częstotliwość',
  'ws.phase': 'C — Przesunięcie fazy',
  'ws.shift': 'D — Przesunięcie pionowe',
  'ws.rform.toggle': 'Postać R',
  'ws.rform.a': 'a (wsp. sin)',
  'ws.rform.b': 'b (wsp. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Resetuj',
  'ws.base': 'Pokaż krzywą bazową',
  'ip.id.pythagorean': 'Pitagorejska',
  'ip.id.reciprocal': 'Odwrotności',
  'ip.id.quotient': 'Ilorazu',
  'ip.id.sum': 'Sumy',
  'ip.id.difference': 'Różnicy',
  'ip.id.double': 'Podwojonego kąta',
  'ip.id.half': 'Połowy kąta',
  'ip.play': 'Odtwórz',
  'ip.pause': 'Pauza',
  'ip.step': 'Krok',
  'ip.reset': 'Resetuj',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  ctg θ = 1/tg θ',
  'ip.proof.quotient.summary': 'tg θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'W v2 — dowód wymaga obszerniejszej konstrukcji.',
  'ts.area': 'Pole',
  'ts.sineRule': 'Twierdzenie sinusów',
  'ts.cosineRule': 'Twierdzenie cosinusów',
  'ts.ambiguous.toggle': 'Widmowy trójkąt przy dwuznaczności',
  'ts.reset': 'Resetuj do równobocznego',
  'ts.snap.integers': 'Przyciągaj do liczb całkowitych',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Boki',
  'ts.section.angles': 'Kąty',
  'ts.section.sineRule': 'Twierdzenie sinusów',
  'ts.section.cosineRule': 'Twierdzenie cosinusów',
  'ts.section.area': 'Pole',
  'cp.omega': 'Prędkość kątowa',
  'cp.plot.y': 'Wykres y (sin)',
  'cp.plot.x': 'Wykres x (cos)',
  'cp.polar.label': 'Figura biegunowa',
  'cp.polar.circle': 'Okrąg (r = 1)',
  'cp.polar.rose': 'Róża (r = sin 3θ)',
  'cp.polar.cardioid': 'Kardioida (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limasona (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Przybliżenie małych kątów (sin x ≈ x)',
  'cp.play': 'Odtwórz',
  'cp.pause': 'Pauza',
  'cp.reset': 'Resetuj',
  'cp.step': 'Krok π/12',
};
